import { render, staticRenderFns } from "./WaybillLoading.vue?vue&type=template&id=2b9d6e48&scoped=true&"
import script from "./WaybillLoading.vue?vue&type=script&lang=js&"
export * from "./WaybillLoading.vue?vue&type=script&lang=js&"
import style0 from "./WaybillLoading.vue?vue&type=style&index=0&id=2b9d6e48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d6e48",
  null
  
)

export default component.exports